import api from './api';

const viewCounterService = {
  /** Increment homepage view counter (no auth required) */
  incrementHomepage: async () => {
    const response = await api.post('/view/increment', { pageType: 'home' });
    return response.data;
  },

  /** Increment gurukul profile view counter (no auth required) */
  incrementGurukul: async (gurukulId) => {
    if (!gurukulId) return;
    const response = await api.post('/view/increment', {
      pageType: 'gurukul',
      gurukulId,
    });
    return response.data;
  },

  /** Get all counters (admin only) */
  getCounters: async () => {
    const response = await api.get('/admin/view-counters');
    return response.data;
  },
};

export default viewCounterService;
